  import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminLayoutRoutes } from './admin-layout.routing';
import { DashboardComponent } from '../../dashboard/dashboard.component';
import { UserProfileComponent } from '../../user-profile/user-profile.component';
import { TableListComponent } from '../../table-list/table-list.component';
import { TypographyComponent } from '../../typography/typography.component';
import { IconsComponent } from '../../icons/icons.component';
import { NotificationsComponent } from '../../notifications/notifications.component';
import { ChartsModule } from 'ng2-charts';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { UpgradeComponent } from '../../upgrade/upgrade.component';
import { LoginComponent } from '../../auth/login/login.component';
import { RestaurantModule } from '../../restaurant/restaurant.module';
import { MapModule } from '../../map/map.module';
import { OrderModule } from '../../order/order.module';
import { CountryCityModule } from '../../country-city/country-city.module';
import { MealsComponent} from '../../meals/meals.component';
// import {ModalModule} from 'angular-custom-modal';
import {AddMealComponent} from '../../meals/add-meal/add-meal.component';


import {MenuComponent} from '../../meals/menu/menu.component';
import {AddMenuComponent} from '../../meals/menu/add-menu/add-menu.component';
import { DriverModule } from '../../driver/driver.module';
import { ShiftModule } from '../../driver-shift/shift.module';

import { CustomerModule } from '../../customer/customer.module';
import { ScaleUnitComponent } from '../../meals/meal-detail/scale-unit/scale-unit.component';
import { IngredientTypeComponent } from '../../meals/meal-detail/ingredient-type/ingredient-type.component';

// import { AddTagComponent } from './tag/add-tag/add-tag.component';
// import { UpdateTagComponent } from '../..tag/update-tag/update-tag.component';

import { TagModule } from '../../tag/tag.module';
import { UpdateMenuComponent } from '../../meals/menu/update-menu/update-menu.component';
import { UpdateMealComponent } from '../../meals/update-meal/update-meal.component';
import { MealDetailComponent } from '../../meals/meal-detail/meal-detail.component';
import { AddonsComponent } from '../../meals/meal-detail/addons/addons.component';
import { ScalesComponent } from '../../meals/meal-detail/scales/scales.component';
import { IngredientComponent } from '../../meals/meal-detail/ingredient/ingredient.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { AddNewMealComponent } from '../../meals/add-new-meal/add-new-meal.component';
import { UpdateIngrediantComponent } from '../../meals/update-ingrediant/update-ingrediant.component';
import { UpdateAddonComponent } from '../../meals/update-addon/update-addon.component';
import { UpdateScaleComponent } from '../../meals/update-scale/update-scale.component';
import { RestaurantTypeComponent } from '../../restaurant-type/restaurant-type/restaurant-type.component';
import { AddRestaurantTypeComponent } from '../../restaurant-type/add-restaurant-type/add-restaurant-type.component';
import { UpdateRestaurantTypeComponent } from '../../restaurant-type/update-restaurant-type/update-restaurant-type.component';
import { CategoryComponent } from '../../category/category/category.component';
import { AddCategoryComponent } from '../../category/add-category/add-category.component';
import { UpdateCategoryComponent } from '../../category/update-category/update-category.component';
// tslint:disable-next-line: max-line-length
import { UpdateIngredientTypeComponent } from '../../meals/meal-detail/ingredient-type/update-ingredient-type/update-ingredient-type.component';
import { UpdateScaleUnitComponent } from '../../meals/meal-detail/scale-unit/update-scale-unit/update-scale-unit.component';
import { ChatComponent } from '../../chat/chat.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(AdminLayoutRoutes),
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    NgbModule,
    RestaurantModule,
    MapModule,
    OrderModule,
    CountryCityModule,
    DriverModule,
    CustomerModule,
    TagModule,
    NgxPaginationModule,
   // NgxPaginationModule,
    ToastrModule.forRoot(),
    ShiftModule
  ],
  declarations: [
   // FilterPipe,
    DashboardComponent,
    UserProfileComponent,
    TableListComponent,
    UpgradeComponent,
    TypographyComponent,
    IconsComponent,
    NotificationsComponent,
    LoginComponent,
    MealsComponent,
    AddMealComponent,
    MenuComponent,
    AddMenuComponent,
    UpdateMenuComponent,
    UpdateMealComponent,
    MealDetailComponent,
    AddonsComponent,
    ScalesComponent,
    IngredientComponent,
    AddNewMealComponent,
    UpdateIngrediantComponent,
    UpdateAddonComponent,
    UpdateScaleComponent,
    RestaurantTypeComponent,
    AddRestaurantTypeComponent,
    UpdateRestaurantTypeComponent,
    ScaleUnitComponent,
    IngredientTypeComponent,
    CategoryComponent,
    AddCategoryComponent,
    UpdateCategoryComponent,
    UpdateIngredientTypeComponent,
    UpdateScaleUnitComponent,
    ChatComponent
  ]
})

export class AdminLayoutModule {}
